export default "__VITE_ASSET__CqWG3E1i__"